export default __webpack_public_path__ + "static/media/05-min.43f30fe2.jpg";